/* src/app/components/editpdf/editpdf.component.css */
.left-panel {
  width: 20%;
  float: left;
}
.right-panel {
  width: 80%;
  display: inline-block;
}
:host {
  display: block;
  height: 100%;
}
.pdf-container {
  height: 100%;
}
/*# sourceMappingURL=editpdf.component-FEJTEM57.css.map */
